import { buildSchema, buildProperty } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const deviceSchema = buildSchema({
    name: "Device",
    properties: {
        name: buildProperty({
            title: "Name",
            validation: { required: true },
            dataType: "string"
        }),
        status: {
            title: "status",
            dataType: "boolean"
        },
        icon: buildProperty({
            title: "Icon",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            validation: { required: true },

        }),
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            validation: { required: true },
        }),
        updatedAt: buildProperty({
            title: "Updated At",
            dataType: "timestamp",
            validation: { required: true },
        }),
    },
    defaultValues: {
        status: false,
    }
});

